import React, {
  Component
} from 'react';
import {
  Card,
}
from "@maxmilhas/hangar-components-atomic/public";
import RulesTable from './RulesTable';

export default class CancellationRulesResume extends Component {
  render = () => {
    let title = "Regras para remarcação e cancelamento para o voo de ida";
    if (this.props.direction === 'inbound') {
      title = "Regras para remarcação e cancelamento para o voo de volta";
    }
    if (!this.props.rules) { 
      return null;
    };
    return (      
      <Card
        title={title}
        selfOpenControl
        type="accordion"
      >
        <RulesTable rules={this.props.rules} />
      </Card>
    );
  }
}